import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class InstallerLogService {
  private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) {}

  searchLogs(body: any): Observable<any> {
    const headers = new HttpHeaders({ accept: '*/*', 'Content-Type': 'application/json' });
    return this.http.post(`${this.apiUrl}/installer/v1/logs/search`, body, { headers });
  }

  getLogContent(id: number): Observable<any> {
    const headers = new HttpHeaders({ accept: '*/*' });
    return this.http.get(`${this.apiUrl}/installer/v1/logs/${id}/content`, { headers });
  }

  getLogContentAsText(id: number): Observable<string> {
    const headers = new HttpHeaders({ accept: 'text/plain, */*' });
    return this.http.get(`${this.apiUrl}/installer/v1/logs/${id}/content`, {
      headers,
      responseType: 'text',
    });
  }
}
